import React from "react";
import BotResponseLayout from "./BotResponseLayout";

function BotExplainImageOptionsLayout({ text, imgSrc, options, onMainMenu, actionProvider }) {
  const buttonStyle = {
    width: "100%",
    padding: "10px 15px",
    margin: "4px 0",
    borderRadius: "8px",
    border: "none",
    backgroundColor: "rgb(0, 89, 164)",
    color: "#fff",
    fontSize: "16px",
    cursor: "pointer",
    transition: "background-color 0.3s",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  };

  return (
    <BotResponseLayout actionProvider={actionProvider}>
      {/* Image */}
      {imgSrc && (
        <div style={{ textAlign: "center", marginBottom: "10px" }}>
          <img
            src={imgSrc}
            alt="Section Preview"
            style={{
              maxWidth: "100%",
              borderRadius: "10px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
            }}
          />
        </div>
      )}

      {/* Explanation */}
      {text && (
        <p style={{ fontSize: "20px", lineHeight: "1.5", color: "#333" }}>
          {text}
        </p>
      )}

      {/* Options */}
      {options?.map((opt, idx) => (
        <button
          key={idx}
          style={buttonStyle}
          onClick={opt.action}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "rgb(0, 100, 200)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "rgb(0, 89, 164)")
          }
        >
          {opt.label}
        </button>
      ))}

    </BotResponseLayout>
  );
}

export default BotExplainImageOptionsLayout;
